<template>
  <div>
     <list
      row-key="WorkDocId"
      ref="list"
      unit="工单管理"
      :page="page"
      show-checkbox
      :show-query="showQuery"
      :get-data-func="api.getDocList"
      v-if="trendShow"
      :queryParamsAppend="{Stage: 0}"
      @check-change="checkChange"
      :temp-params="tempParams"
      urlHash="production/ticketmanagement/workorder/glue"
      :showIndex="true"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>

import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      trendShow: true,
      tempParams: {},
      // params: {
      //   CustomerName: "",
      //   Stage: null, //注塑/胶件加工/配件装配/产品装配/产品组装
      //   OrderNo: "",
      //   WorkDocNo: "",
      //   CompletionStartDate: null,
      //   CompletionEndDate: null,
      //   DocStartDate: null,
      //   DocEndDate: null,
      //   WorkDocType: null,
      //   ProductType: null,
      //   ProductName: "",
      //   Status: null,
      // },
      isMB: this.$store.state.isMB,
      list: [],
    };
  },
  activated(){
    this.getRouterInfo()
  },
  methods: {
    getRouterInfo(){
      if(this.$router.history.current.params){
        this.tempParams.OrderNo= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderNo
        }
        if(this.$router.history.current.params.type === '明细' && this.$router.history.current.params.DocType === '注塑工单'){
          this.tempParams.WorkDocNo={
            paramValueType: 'resetParamValue',
            isReset: true,
            value: this.$router.history.current.params.DocNo
          }
        }
        this.tempParams.ProductionType={
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.ProductionType
        }
        this.tempParams.Ids= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        }
        this.$refs.list.getData()
      }    
    },
    color(row) {
      if (row.Status == 7) return "c-lightgray";
      if (row.Status == 6) return "c-danger";
    },
    checkChange(list){
      this.list = list
    },
    del() {
      let ids = this.list.map(item => {
        return item.WorkDocId;
      })
      let flag = []; 
      this.list.forEach(item => {
        if (item.Status == 3) {
          if (!flag.includes('已审核')) {
            flag.push('已审核')
          }
        }
        if (item.Status == 4) {
          if (!flag.includes('生产中')) {
            flag.push('生产中')
          }
        }
        if (item.Status == 5) {
          if (!flag.includes('已完成')) {
            flag.push('已完成')
          }
        }
        if (item.Status == 6) {
          if (!flag.includes('终止通知')) {
            flag.push('终止通知')
          }
        }
        if (item.Status == 7) {
          if (!flag.includes('终止完成')) {
            flag.push('终止完成')
          }
        }
      })
      if (flag.length > 0) {
        this.$message.warning(`勾选的单据包含${flag.join(',')}内容`)
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      })
      
    },
  },
};
</script>